export function raToDegrees(ra: string): number {
  const [h, m, s] = ra.split(/\s+/).map(Number)
  return (h + m / 60 + s / 3600) * 15
}

export function decToDegrees(dec: string): number {
  const [d, m, s] = dec.split(/\s+/)
  const sign = d.startsWith("-") ? -1 : 1
  const absD = Math.abs(parseFloat(d))
  const minutes = parseFloat(m)
  const seconds = parseFloat(s)
  return sign * (absD + minutes / 60 + seconds / 3600)
}



